export const CampaignTableColumn = [
  'Booking Id',
  'Start Date',
  'End Date',
  'Screens',
  'Impression',
  'View',
  'Interval',
  'Cost',
  'Status',
];

export const MyBookingTableColumn = [
  'Booking Id',
  'Start Date',
  'End Date',
  'Screens',
  'Impression',
  'View',
  'Interval',
  'Cost',
  'Status',
];

export const AdminCampaignTableColumn = [
  'Booking Id',
  'Start Date',
  'End Date',
  'Screens',
  'Impression',
  'View',
  'Interval',
  'Cost',
  'Status',
];
